import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box } from 'reflexbox';

import config from 'frontend/config';

class SliderDebounced extends React.Component {
  state = {
    value: 0,
    acting: false,
  }

  static propTypes = {
    value: PropTypes.number,
    delay: PropTypes.number,
    height: PropTypes.number,
    width: PropTypes.number,
    ticks: PropTypes.array,
    min: PropTypes.number,
    max: PropTypes.number,
    inputMax: PropTypes.number,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: 0,
    delay: 300,
    height: 30,
    width: 300,
    min: 0,
    max: 100,
    inputMax: null,
    ticks: [],
  }

  constructor(props) {
    super(props);

    this.state.value = props.value;
    this.debouncedOnChange = _.debounce(value => {
      this.props.onChange(value);
      this.setState({ acting: false });
    }, this.props.delay);
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.acting && props.value !== state.value) {
      return {
        ...state,
        value: props.value,
      };
    }
    return state;
  }

  onChange = (e) => {
    this.setState({ acting: true });
    let value = parseInt(e.target.value);
    if (!value) {
      value = 0;
    }
    if (value < 0) {
      value = 0;
    }
    const max = this.props.inputMax || this.props.max;
    if (value > max) {
      value = max;
    }
    this.setState({ value });
    this.debouncedOnChange(value);
  }

  render() {
    const { value } = this.state;
    const { width, height, ticks, min, max } = this.props;
    return (
      <Flex align="center" style={{ width }}>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          style={{ height, width: '100%', margin: 0 }}
          list="range-ticks"
          onChange={this.onChange}
        />
        <datalist id="range-ticks">
          {_.map(ticks, tick => (
            <option key={tick} value={tick} label={tick} />
          ))}
        </datalist>
        <Box ml={1} col={2}>
          <input
            type="number"
            value={value || 0}
            onChange={this.onChange}
            style={{
              width: 34,
              fontSize: 12,
              padding: 4,
              color: config.colors.white,
              backgroundColor: 'rgba(255, 255, 255, .25)',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: config.borderColor,
              borderRadius: 5,
            }}
          />
        </Box>
      </Flex>
    );
  }
}

export default SliderDebounced;
